<script setup>
import {DateTime} from 'luxon'

import {useReservationStore} from "../stores/reservation"
const reservationStore = useReservationStore()

const props = defineProps({
    timeslot: Object
})

</script>
<template>
    <button
        class="d-flex align-items-center justify-content-between btn w-100 mt-2 btn-secondary"
        :disabled="!timeslot.available"
        @click="reservationStore.setTime(timeslot)"
        :class="{
                'btn-outline' : (reservationStore.time === timeslot || !timeslot.available),
            }"
        >
        <span>
            {{ DateTime.fromISO(timeslot.startTime).toFormat('HH:mm') }}
            -
            {{ DateTime.fromISO(timeslot.endTime).toFormat('HH:mm') }}
        </span>
        <span class="font-weight-medium text-end" v-if="reservationStore.reservation === null">
            <template v-if="timeslot.pricing && !timeslot.pricing.paymentRequired">
                {{ $t('reservation.price.included') }}
            </template>
            <template v-else>
                {{ timeslot.pricing ? timeslot.pricing.payablePrice.formatted : timeslot.price.formatted }}
            </template>
            <small class="d-block" v-if="timeslot.pricing && timeslot.pricing.fundingLabel">
                {{ timeslot.pricing.fundingLabel }}
            </small>
            <small class="d-block" v-if="timeslot.pricing && timeslot.pricing.notice">
                {{ timeslot.pricing.notice }}
            </small>
        </span>
        <small class="font-weight-medium" v-if="reservationStore.isCurrentReservation(timeslot)">
                {{$t('reservation.edit.current')}}
        </small>
    </button>
</template>
